var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_190",
    "data-name": "\\uADF8\\uB8F9 190",
    transform: "translate(-989 -1379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_55",
    "data-name": "\\uC0AC\\uAC01\\uD615 55",
    transform: "translate(989 1379)",
    fill: "#fff",
    stroke: "#e4e4e4",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_28",
    "data-name": "\\uC120 28",
    y1: 20,
    x2: 20,
    transform: "translate(999 1389)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_29",
    "data-name": "\\uC120 29",
    x1: 20,
    y1: 20,
    transform: "translate(999 1389)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 6
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.5f90117b88f348061e7915d74e4dc8ba.svg";
export { ForwardRef as ReactComponent };